export default __webpack_public_path__ + "static/media/client-logo-6.9431f285.png";